var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cta-section" },
    [
      _c(
        "el-row",
        { staticClass: "cta-section-inner" },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "cta-main" }, [
              _c("h2", { staticClass: "cta-title" }, [
                _vm._v("Join UNIFI Property Today")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "cta-description" }, [
                _vm._v(
                  "\n            Be part of a forward-thinking real estate platform that's transforming how off-the-plan properties are bought and sold. Join UNIFI Property and connect with serious buyers ready to reserve their future homes online. Whether you represent a single property or a large-scale development, our platform is here to make the sales process smoother, faster, and more effective.\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cta-secondary" }, [
              _c("h3", { staticClass: "secondary-title" }, [
                _vm._v("Ready to Grow Your Business?")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "secondary-description" }, [
                _vm._v(
                  "\n            Sign up today to start listing your off-the-plan properties with UNIFI Property. Connect with the buyers who value new, modern living options—and take your sales to the next level with our streamlined, buyer-focused platform.\n          "
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-group" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "join-btn",
                      attrs: { type: "primary", size: "large" },
                      on: {
                        click: function($event) {
                          return _vm.requestAgentKit()
                        }
                      }
                    },
                    [_vm._v("\n            REQUEST AGENT KIT\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "sign-in-btn",
                      attrs: { type: "primary", size: "large" },
                      on: { click: _vm.redirectToAgentLogin }
                    },
                    [_vm._v("\n            SIGN IN\n          ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55f03ca0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55f03ca0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/agentRegistration/agentRegistrationSection4.vue
// module id = null
// module chunks = 